import { Menu, MenuProps } from '@mui/material'
import { FC } from 'react'

const MenuWrapper: FC<MenuProps> = ({ ...props }) => <Menu {...props} />

export default MenuWrapper
